import { shouldAnimate, readEnv, idle } from './gm-motion.js';
const hero = document.querySelector('[data-gm-hero]');
if (hero) {
  const th = hero.querySelector('.gm-hero__thermal'), temp = hero.querySelector('[data-gm-temp]'), btn = hero.querySelector('[data-gm-thermal-toggle]');
  const set = (r, x, y) => { th.style.setProperty('--r', r + 'px'); th.style.setProperty('--x', x + '%'); th.style.setProperty('--y', y + '%'); };
  // Label stays "Thermal cam"; aria-pressed carries the state (and drives the CSS on/off dot).
  btn.addEventListener('click', () => { const on = hero.classList.toggle('is-thermal'); btn.setAttribute('aria-pressed', String(on)); });
  hero.addEventListener('pointermove', (e) => {
    const b = hero.getBoundingClientRect(), x = (e.clientX - b.left) / b.width * 100, y = (e.clientY - b.top) / b.height * 100;
    set(Math.min(innerWidth, innerHeight) * .28, x, y); temp.textContent = (68 + Math.round((1 - y / 100) * 31)) + '°F'; // 68–99°F
  });
  hero.addEventListener('pointerleave', () => set(0, 50, 40));
  if (shouldAnimate(readEnv())) idle(() => {                     // one discoverability sweep, CSS-driven (no GSAP here)
    let t0; const R = Math.max(innerWidth, innerHeight);
    const step = (t) => { t0 ??= t; const p = Math.min(1, (t - t0) / 1800), r = p < .5 ? R * (p * 2) : R * (2 - p * 2); set(r, 50, 45); if (p < 1) requestAnimationFrame(step); };
    requestAnimationFrame(step);
  });
}
